const DROP_TAGS = new Set([
  'script',
  'iframe',
  'object',
  'embed',
  'link',
  'meta',
  'base',
  'form',
  'svg',
  'math',
  'applet',
  'frame',
  'frameset',
  'template',
])

function dangerousUrl(value: string): boolean {
  const cleaned = value.replace(/[\u0000-\u0020]+/g, '').trim()
  if (/^data:image\/(png|jpe?g|gif|webp);base64,/i.test(cleaned)) return false
  return /^(javascript|vbscript|data):/i.test(cleaned)
}

/** Removes scripts and active URLs before mailbox HTML is shown. */
export function sanitizeEmailHtml(html: string): string {
  const source = html.trim()
  if (!source || typeof DOMParser === 'undefined') return ''
  const doc = new DOMParser().parseFromString(source.slice(0, 500000), 'text/html')
  doc.querySelectorAll([...DROP_TAGS].join(',')).forEach((node) => node.remove())
  doc.body.querySelectorAll('*').forEach((element) => {
    ;[...element.attributes].forEach((attr) => {
      const name = attr.name.toLowerCase()
      if (name.startsWith('on') || name === 'srcdoc') {
        element.removeAttribute(attr.name)
        return
      }
      if ((name === 'href' || name === 'src' || name === 'action' || name === 'formaction') && dangerousUrl(attr.value)) {
        element.removeAttribute(attr.name)
      }
    })
  })
  return doc.body.innerHTML
}

/** Rejects a comma or semicolon list that is not only email addresses. */
export function invalidRecipientMessage(raw: string, label = 'Cc'): string | null {
  const parts = raw
    .split(/[;,]/)
    .map((part) => part.trim())
    .filter(Boolean)
  if (parts.length > 20) return `${label} is limited to 20 addresses.`
  const bad = parts.some((part) => /[\r\n]/.test(part) || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(part))
  return bad ? `${label} contains an address that is not a valid email.` : null
}
